/**
 * Maps font family names to their corresponding Tailwind CSS classes
 */
export const getFontClass = (fontFamily: string): string => {
  const fontMap: Record<string, string> = {
    cardo: "font-cardo",
    Cardo: "font-cardo",
    sourcecodepro: "font-sourcecodepro",
    "Source Code Pro": "font-sourcecodepro",
    "source-code-pro": "font-sourcecodepro",
    "Source Sans Pro": "font-source-sans-pro",
    "source-sans-pro": "font-source-sans-pro",
    noto: "font-noto",
    "Noto Sans": "font-noto-sans",
    "noto-sans": "font-noto-sans",
    lato: "font-lato",
    Lato: "font-lato",
    dancing: "font-dancing",
    "Dancing Script": "font-dancing-script",
    "dancing-script": "font-dancing-script",
    roboto: "font-roboto",
    Roboto: "font-roboto",
    nunito: "font-nunito",
    "Nunito Sans": "font-nunito-sans",
    "nunito-sans": "font-nunito-sans",
  };

  return fontMap[fontFamily] || "font-sans"; // fallback to font-sans
};
